export default "__VITE_ASSET__yDKH$tbN__"